module.exports = __webpack_public_path__ + "static/img/honor19.c93bc54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor19.png
// module id = NYPO
// module chunks = 0